import ManualPassport from "@/types/clients/esquire/data/general/manual-passport";

export default class PostManualPassportPayload {
  constructor(private passport: ManualPassport, private contractId: string) {}

  public toJson(): Record<string, unknown> {
    return {
      contract_id: this.contractId,
      manual_passport: this.passport.toPayload()
    };
  }
}
